import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createContext } from "react";
import Grid from "@mui/material/Grid2";
import Paper from "@mui/material/Paper";
import TableContainer from "@mui/material/TableContainer";
import Typography from "@mui/material/Typography";
import styled from "@mui/material/styles/styled";
import { useShowDebugOther } from "@plansoft-configuration-renderer/debug";
import { DataTable } from "../DataTable";
import { useDataTableNumberFormatter, } from "../DataTable/useDataTableNumberFormatter";
import { useDataTablePriceFormatter, } from "../DataTable/useDataTablePriceFormatter";
import RenderCellAccordion from "./renderer/RenderCellAccordion";
import RenderCellDebug from "./renderer/RenderCellDebug";
import RenderCellPrices from "./renderer/RenderCellPrices";
var ColumnField;
(function (ColumnField) {
    ColumnField["Name"] = "name";
    ColumnField["Value"] = "value";
    ColumnField["TypeCodeFragment"] = "typeCodeFragment";
    ColumnField["Debug"] = "debug";
    ColumnField["Prices"] = "prices";
})(ColumnField || (ColumnField = {}));
export const ConfigurationSummaryContext = createContext({});
export const ConfigurationSummaryIsCollapsibleContext = createContext(false);
function getIsCollapsible(data) {
    let boolean = false;
    data.forEach((attribute) => {
        if (attribute.configurations && attribute.configurations.length > 0) {
            boolean = true;
        }
    });
    return boolean;
}
export function formatConfigurationSummaryAttributesToDataTableRows(data, columns, formatPrice, formatNumber, level) {
    const rows = data.map((row) => {
        var _a, _b, _c, _d;
        const rowsTmp = [];
        (_a = row.configurations) === null || _a === void 0 ? void 0 : _a.forEach((configuration) => {
            var _a;
            if (configuration.attributes) {
                (_a = formatConfigurationSummaryAttributesToDataTableRows(configuration.attributes, columns, formatPrice, formatNumber, level + 1)) === null || _a === void 0 ? void 0 : _a.forEach((row) => {
                    rowsTmp.push(row);
                });
            }
        });
        const values = (_b = row.values) === null || _b === void 0 ? void 0 : _b.map((value) => {
            return value.name;
        });
        const prices = (_c = row.values) === null || _c === void 0 ? void 0 : _c.map((value) => {
            var _a;
            const valuePrices = (_a = value.prices) === null || _a === void 0 ? void 0 : _a.map((price) => {
                if (!price.price)
                    return;
                return formatPrice(price.price, price.unitId);
            });
            return valuePrices ? valuePrices.join(", ") : undefined;
        });
        const typeCodeStringArray = (_d = row.values) === null || _d === void 0 ? void 0 : _d.map((value) => value.typeCodeFragment);
        const rowTmp = {
            id: row.id,
            name: row.name,
            typeCodeFragment: typeCodeStringArray === null || typeCodeStringArray === void 0 ? void 0 : typeCodeStringArray.join(""),
            level: level,
            rows: rowsTmp,
            debug: row,
            value: values === null || values === void 0 ? void 0 : values.join(", "),
            prices: prices,
        };
        return rowTmp;
    });
    return rows;
}
/**
 * Display configuration summary
 * @param props
 * @returns
 */
export function ConfigurationSummaryDisplay({ data, languageCode, }) {
    var _a, _b, _c, _d, _e, _f, _g;
    const showDebug = useShowDebugOther();
    const formatPrice = useDataTablePriceFormatter(languageCode);
    const formatNumber = useDataTableNumberFormatter(languageCode);
    // interface like GridColDef from mui5
    const columns = [
        {
            field: ColumnField.Name,
            headerName: "Attribute",
            renderCell: RenderCellAccordion,
        },
        { field: ColumnField.Value, headerName: "Value" },
        { field: ColumnField.TypeCodeFragment, headerName: "Typecode-Fragment" },
        {
            field: ColumnField.Prices,
            headerName: "Prices",
            renderCell: RenderCellPrices,
        },
        {
            field: ColumnField.Debug,
            headerName: "Debug",
            renderCell: RenderCellDebug,
        },
    ];
    const visibleFields = [
        ColumnField.Name,
        ColumnField.Value,
        ColumnField.Prices,
        ColumnField.TypeCodeFragment,
    ];
    if (showDebug) {
        visibleFields.push(ColumnField.Debug);
    }
    const filteredConfigurationSummaryAttributes = (_b = (_a = data.rootObject) === null || _a === void 0 ? void 0 : _a.attributes) === null || _b === void 0 ? void 0 : _b.filter((attribute) => (attribute.values && attribute.values.length > 0) ||
        (attribute.configurations && attribute.configurations.length > 0));
    const rows = filteredConfigurationSummaryAttributes
        ? formatConfigurationSummaryAttributesToDataTableRows(filteredConfigurationSummaryAttributes, columns, formatPrice, formatNumber, 1)
        : undefined;
    const isCollapsible = filteredConfigurationSummaryAttributes
        ? getIsCollapsible(filteredConfigurationSummaryAttributes)
        : false;
    const Image = styled("img")(() => ({
        width: "100%",
    }));
    return (_jsx(ConfigurationSummaryContext.Provider, { value: data, children: _jsxs(ConfigurationSummaryIsCollapsibleContext.Provider, { value: isCollapsible, children: [((_c = data.rootObject) === null || _c === void 0 ? void 0 : _c.typeCode) && (_jsx(Typography, { variant: "h5", sx: {
                        pb: 2,
                    }, children: data.rootObject.typeCode })), _jsxs(Grid, { container: true, spacing: 2, children: [((_d = data.rootObject) === null || _d === void 0 ? void 0 : _d.image) && (_jsx(Grid, { size: 2, children: _jsx(Image, { alt: (_f = (_e = data.rootObject) === null || _e === void 0 ? void 0 : _e.name) !== null && _f !== void 0 ? _f : "", src: (_g = data.rootObject) === null || _g === void 0 ? void 0 : _g.image }) })), rows && (_jsx(Grid, { size: "grow", children: _jsx(TableContainer, { component: Paper, sx: { width: "100%", maxHeight: "calc(75vh - 150px)" }, children: _jsx(DataTable, { rows: rows, columns: columns, visibleFields: visibleFields }) }) }))] })] }) }));
}
//# sourceMappingURL=ConfigurationSummaryDisplay.js.map